import bus_horizontal from "./Images/bus horizontal safaria.png";
import safariabus from "./Images/safariabus.jpg";
import appImage from "./Images/appImage.png";
import SafariaLogo from "./Images/Safaria.png";
import Safaria_logo_white from "./Images/Safaria_logo_white.png";
import worldWelcome from "./Images/wordImg-removebg-preview-04.png";
import seat from "./Images/car-seat 1 (1).png";
import seatFree from "./Images/availableChair_v2-01-01-01-01.png";
import seat_notFree from "./Images/reservedChair_v2-01-01-01.png";
import seat_reserved from "./Images/selectedChair_v2-01-01.png";
import booked from "./Images/booked.png";
import steering_wheel from "./Images/steering_wheel.png";
import toilet_img from "./Images/toilet_img.png";
import door from "./Images/door-02.png";
import Im_404 from "./Images/illustration.png";
import paymentSuccess from "./Images/paymentSuccess.png";
import Secured from "./Images/Secured.png";
import safariaMobile from "./Images/safariaMobile.png";
import railWay from "./Images/RAILWAY.png";
import trainSafaria from "./Images/TRAINSAFARIA.png";
import listBg from "./Images/listBg.jpg";
import listBg2 from "./Images/listBg2.jpg";
import fawry from "./Images/fawry.jpg";
import instapay from "./Images/instapay.jpg";
import orangecash from "./Images/orangecash.jpg";
import vodafonecash from "./Images/vodafonecash.jpg";
import etisalat from "./Images/etisalat.jpg";
import taka from "./Images/taka.jpg";
import aman from "./Images/aman.jpg";
import blnk from "./Images/blnk.jpg";
import contact from "./Images/contact.jpg";
import halan from "./Images/halan.jpg";
import mastercard from "./Images/mastercard.jpg";
import visa from "./Images/visa.jpg";
import valw from "./Images/valw.jpg";
import Cairo_1 from "./Images/Cairo-1.png";
import Cairo_2 from "./Images/cairo-1 (1).png";
import Sharm_1 from "./Images/Sharm-1.png";
import Sharm_2 from "./Images/sharm-2.png";
import luxor from "./Images/luxor1.png";
import luxor2 from "./Images/luxor 2.png";
import hurghada from "./Images/hurghada-.png";
import hurghada3 from "./Images/hurghada-3.png";
import dahap from "./Images/Dahab-.png";
import dahap2 from "./Images/dahab 2.png";
import alex from "./Images/alex-1.png";
import sohag from "./Images/sohag,-sohag-city,-sohag-travel.jpg";

const images = {
  bus_horizontal,
  safariabus,
  fawry,
  instapay,
  orangecash,
  vodafonecash,
  etisalat,
  taka,
  aman,
  blnk,
  contact,
  halan,
  mastercard,
  visa,
  valw,
  appImage,
  SafariaLogo,
  Safaria_logo_white,
  worldWelcome,
  seat,
  seatFree,
  seat_notFree,
  seat_reserved,
  steering_wheel,
  toilet_img,
  booked,
  door,
  Im_404,
  paymentSuccess,
  Secured,
  safariaMobile,
  trainSafaria,
  railWay,
  listBg,
  listBg2,
  Cairo_1,
Cairo_2,
Sharm_1,
Sharm_2,
luxor,
luxor2,
hurghada,
hurghada3,
dahap,
dahap2,
alex,
sohag
};

export default images;
